/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Inbounds_In_ExceptionInputs */

const en_queue_inbounds_in_exception = /** @type {(inputs: Queue_Inbounds_In_ExceptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inbounds in exception`)
};

/**
* | output |
* | --- |
* | "Inbounds in exception" |
*
* @param {Queue_Inbounds_In_ExceptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_inbounds_in_exception = /** @type {((inputs?: Queue_Inbounds_In_ExceptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Inbounds_In_ExceptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_inbounds_in_exception(inputs)
});